import { genericFetchingActionCreator } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

const fetchAssignmentList = (listType, listName, days) => {
  return (dispatch, getState) => {
    const id = getState().currentUser.entities.find(e => e.name === 'AppraiserInspector').values.id
    dispatch(genericFetchingActionCreator(listName, 'fetching'))
    fetch(`/lgyhub/api/appraiser-workspace/appraiser/${id}/assignments/${listType}${days ? `?days=${days}` : ''}`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'the Appraiser Workspace')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else { //success
        let list = { list: responseJson }
        dispatch(genericFetchingActionCreator(listName, 'fetched', list))
      }
    }).catch((error) => {
      dispatch(genericFetchingActionCreator(listName, 'error'))
      console.error('Appraiser fetching error: ', error)
    })
  }
}

export const fetchPendingAssignments = () => fetchAssignmentList('ACTIVE', 'PENDING_ASSIGNMENTS')
export const fetchCanceledAssignments72Hrs = () => fetchAssignmentList('CANCELLED', 'CANCELED_ASSIGNMENTS_72_HOURS', 3)
export const fetchAllAssignments90Days = () => fetchAssignmentList('ALL', 'ALL_ASSIGNMENTS_90_DAYS', 90)
export const fetchAssignmentsWithUploads30Days = () => fetchAssignmentList('UPLOADS', 'ASSIGNMENTS_WITH_UPLOADS_30_DAYS', 30)
export const fetchCanceledAssignments90Days = () => fetchAssignmentList('CANCELLED', 'CANCELED_ASSIGNMENTS_90_DAYS', 90)
export const fetchUnacceptedAssignments = () => fetchAssignmentList('UNACCEPTED', 'UNACCEPTED_ASSIGNMENTS')

const fetchAllAssignmentLists = () => {
  return (dispatch) => {
    dispatch(fetchPendingAssignments())
    dispatch(fetchCanceledAssignments72Hrs())
    dispatch(fetchAllAssignments90Days())
    dispatch(fetchAssignmentsWithUploads30Days())
    dispatch(fetchCanceledAssignments90Days())
    dispatch(fetchUnacceptedAssignments())
  }
}

export default fetchAllAssignmentLists
